<template>
  <el-card shadow="never" class="ymd_card">
    <div slot="header" v-if="title">
      <h4>{{ title }}</h4>
    </div>
    <el-radio-group v-model="type" style="margin-bottom: 30px">
      <el-radio-button label="year">{{
        language("ymdCard.typeYear")
      }}</el-radio-button>
      <el-radio-button label="month">{{
        language("ymdCard.typeMonth")
      }}</el-radio-button>
      <el-radio-button label="date">{{
        language("ymdCard.typeDay")
      }}</el-radio-button>
    </el-radio-group>
    <div>
      <el-form :label-width="labelWidth" :label-position="labelPosition">
        <el-form-item
          :label="language('ymdCard.typeYear')"
          class="item"
          v-if="type == 'year'"
        >
          <el-date-picker
            v-model="year"
            type="year"
            :placeholder="language('ymdCard.year')"
            value-format="yyyy"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="language('ymdCard.typeMonth')"
          class="item"
          v-if="type == 'month'"
        >
          <el-date-picker
            v-model="month"
            type="month"
            :placeholder="language('ymdCard.month')"
            value-format="MM"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="language('ymdCard.typeDay')"
          class="item"
          v-if="type == 'date'"
        >
          <el-date-picker
            v-model="date"
            type="date"
            :placeholder="language('ymdCard.date')"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    title: String,
    labelWidth: {
      type: String,
      default: "80px",
    },
    labelPosition: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {
      year: "",
      month: "",
      date: "",
      type: "year",
    };
  },
};
</script>
<style >
.ymd_card .el-form-item__label {
  font-weight: 600;
}
</style>
<style scoped>
.item {
  margin-bottom: 0;
}
.ymd_card {
  height: 100%;
}
</style>